import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import CategoryService from "../services/CategoryService";

export const CategoryContext = createContext("CategoryContext");

const CategoryContextProvider = ({ children }) => {
	const [categoryList, setCategoryList] = useState([]);
	const [parentCategoryList, setParentCategoryList] = useState([]);
	const [loadingCategoryList, setLoadingCategoryList] = useState(false);
	const [loadingParentCategoryList, setLoadingParentCategoryList] =
		useState(false);
	const [categoryListErrorMsg, setCategoryListErrorMsg] = useState("");
	const [totalElements, setTotalElements] = useState(0);

	const getCategoryList = async (params) => {
		setLoadingCategoryList(true);
		setCategoryListErrorMsg("");
		try {
			const response = await CategoryService.getCategoryList(params);
			setTotalElements(response.data.totalElements);
			setCategoryList(response.data.content);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setCategoryListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingCategoryList(false);
		}
	};

	const getParentCategoryList = async (params) => {
		setLoadingParentCategoryList(true);
		setCategoryListErrorMsg("");
		try {
			const response =
				await CategoryService.getParentCategoryList(params);
			setParentCategoryList(response.data);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			Toast("error", "Error", message);
		} finally {
			setLoadingParentCategoryList(false);
		}
	};

	return (
		<CategoryContext.Provider
			value={{
				getCategoryList,
				getParentCategoryList,
				categoryList,
				loadingCategoryList,
				categoryListErrorMsg,
				parentCategoryList,
				loadingParentCategoryList,
				totalElements,
			}}
		>
			{children}
		</CategoryContext.Provider>
	);
};

export default CategoryContextProvider;
